import { render, staticRenderFns } from "./AlertsList.vue?vue&type=template&id=17a2207c&scoped=true"
import script from "./AlertsList.vue?vue&type=script&lang=js"
export * from "./AlertsList.vue?vue&type=script&lang=js"
import style0 from "./AlertsList.vue?vue&type=style&index=0&id=17a2207c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a2207c",
  null
  
)

export default component.exports